import { Check } from 'lucide-react';
import AutoVideo from './AutoVideo';

// sai's Showcase: the band at the top of a product page, the product's own
// showreel playing by itself, beside the few things it shows.
//   video  — see VIDEOS in DemoVideo.js
//   title, points — the band's heading and the short list beside the video
//   soundId, playId — data-trapezium-ids for the video's two buttons
//   action — optional call to action under the points
//   rate   — optional playback speed (default 1; the Smart Report reel plays at 0.8)
export default function Showcase({ video, title, points, soundId, playId, action, rate = 1 }) {
  return (
    <section className="showcase" aria-label={title}>
      <AutoVideo video={video} soundId={soundId} playId={playId} rate={rate} />
      <div className="showcase-copy">
        <p className="showcase-h">{title}</p>
        <ul>
          {points.map((p) => (
            <li key={p}>
              <Check size={14} strokeWidth={3} aria-hidden="true" />
              {p}
            </li>
          ))}
        </ul>
        {action}
      </div>
    </section>
  );
}
